import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/category/${movie.category}`}
      className="group block rounded-lg overflow-hidden bg-background-100 hover:bg-background-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[2/3] overflow-hidden">
        <img
          src={movie.image}
          alt={movie.title}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-transparent to-transparent"></div>

        {movie.isNew && (
          <span className="absolute top-2 left-2 bg-accent-500 text-foreground-50 text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
            新上线
          </span>
        )}
        {movie.isHot && (
          <span className="absolute top-2 right-2 bg-primary-500 text-background-950 text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
            热播
          </span>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <div className="flex items-center gap-1 mb-1">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-star-fill text-primary-500 text-xs"></i>
            </div>
            <span className="text-primary-400 text-sm font-medium">{movie.rating}</span>
            <span className="text-foreground-400 text-xs ml-1">{movie.year}</span>
          </div>
          <h3 className="text-foreground-50 font-heading text-base leading-tight line-clamp-1">
            {movie.title}
          </h3>
        </div>
      </div>

      <div className="p-3">
        <div className="flex flex-wrap gap-1">
          {movie.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="text-xs text-secondary-400 bg-secondary-100/20 px-2 py-0.5 rounded-full whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
        <p className="text-foreground-500 text-xs mt-2 line-clamp-2 leading-relaxed">
          {movie.description}
        </p>
      </div>
    </Link>
  );
}